// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { OptionsWrapper } from './styles'
import CopyProject from './CopyProject'
import DeleteProject from './DeleteProject'
import PathReports from './PathReports'

const Options = props => {
  const {
    hasHighlighted,
    idRoot,
    isOpen,
    setModalTemplate,
    sourceForm,
  } = props

  return (
    <OptionsWrapper className={isOpen ? ' active' : ''}>
      <CopyProject
        hasHighlighted={hasHighlighted}
        idRoot={idRoot}
        setModalTemplate={setModalTemplate} />
      <DeleteProject
        hasHighlighted={hasHighlighted}
        idRoot={idRoot}
        setModalTemplate={setModalTemplate}
        sourceForm={sourceForm} />
      <PathReports
        hasHighlighted={hasHighlighted}
        idRoot={idRoot}
        setModalTemplate={setModalTemplate} />
    </OptionsWrapper>
  )
}

Options.propTypes = {
  hasHighlighted: bool.isRequired,
  idRoot: string.isRequired,
  isOpen: bool.isRequired,
  setModalTemplate: func.isRequired,
  sourceForm: string.isRequired,
}

export default Options
